import { PromptSettingsLiveStatus } from 'src/components/Prompt/constants';
import { TerritoryLivePromptActiveFilter } from 'src/components/TerritoryFilter/constants';
import { mapFilterToLiveStatus } from './mapFilterToLiveStatus';
import { TPromptsData } from '../../PromptsListSection/types';

export const getFilteredLivePrompts = (
  prompts: TPromptsData[] | undefined,
  livePromptStatus: TerritoryLivePromptActiveFilter | undefined,
) => {
  if (!prompts) return [];

  let statusToFilter: PromptSettingsLiveStatus | undefined;

  switch (livePromptStatus) {
    case TerritoryLivePromptActiveFilter.active:
    case TerritoryLivePromptActiveFilter.upcoming:
    case TerritoryLivePromptActiveFilter.completed:
      statusToFilter = mapFilterToLiveStatus(livePromptStatus);
      return prompts.filter((prompt) => prompt.promptSettings?.liveStatus === statusToFilter);
    default:
      return prompts;
  }
};
